export default __webpack_public_path__ + "static/2307-3de8bb917590fd27fb227865815824de.gif";